import api from '../services/api';

const pending = new Map();
const lastRecorded = new Map();
const DEBOUNCE_MS = 2000;

/** Record a tool visit for the logged-in user (debounced). Returns updated recent tools when recorded. */
export function recordToolVisit({ toolKey, name, path }) {
  if (!toolKey || !name || !path) return Promise.resolve(null);

  const key = `${toolKey}:${path}`;
  const now = Date.now();
  const last = lastRecorded.get(key);
  if (last && now - last < DEBOUNCE_MS) return Promise.resolve(null);

  if (pending.has(key)) return pending.get(key);

  lastRecorded.set(key, now);
  const promise = api
    .post('/auth/dashboard-prefs/recent-tools', { toolKey, name, path })
    .then((res) => res?.data ?? null)
    .catch(() => null)
    .finally(() => {
      pending.delete(key);
    });

  pending.set(key, promise);
  return promise;
}
